export enum AltLayout {
  NULL = 'null',
  COPY = 'copy',
  ROTATE = 'rotate',
  MIRROR = 'mirror',
  CUSTOM = 'custom',
}
